export default {
	"Progress.remainder": "剩余"
}